import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { ErrorBoundary } from "./components/error-boundary";
import ImpersonationIndicator from "./components/impersonation-indicator";
import "./index.css";
import { AppContextProvider } from "./providers/app-context.component";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

if (import.meta.env.VITE_ENV && import.meta.env.VITE_ENV !== "local") {
  Sentry.init({
    dsn: "https://a39120e9cb735478ac55f68078d863bd@o4509078891331584.ingest.us.sentry.io/4509091141844992",
    environment: import.meta.env.VITE_ENV,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContextProvider>
          <ErrorBoundary>
            <ImpersonationIndicator />
            <App />
          </ErrorBoundary>
        </AppContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
